import React from 'react';
import axios from 'axios';

export default function DeleteProductModal({ product, onClose, onUpdateScreen }) {
    const handleDelete = async () => {
        try {
            // Faz a requisição para excluir o produto
            await axios.delete(`${process.env.REACT_APP_API_URL || "https://api.clelton-churrasqueiras.site"}/productRoutes/product/${product.id}`);

            // Atualiza a tela após a exclusão
            onUpdateScreen();

            // Fecha o modal após a exclusão
            onClose();
        } catch (error) {
            console.error('Erro ao excluir o produto:', error);
            alert('Não foi possível excluir o produto. Tente novamente mais tarde.');
        }
    };

    if (!product) {
        return null; // Evita renderizar se nenhum produto foi selecionado
    }

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
            <div className="glass-panel p-6 w-full max-w-2xl text-white max-w-md">
                <h2 className="text-xl font-bold text-white mb-6 tracking-wide">Excluir Produto</h2>
                <p>Tem certeza que deseja excluir o produto <strong>{product.nome}</strong>?</p>
                <div className="flex justify-end mt-6 space-x-4">
                    <button
                        onClick={onClose}
                        className="bg-gray-300 hover:bg-gray-400 text-white py-2 px-4 rounded-md"
                    >
                        Cancelar
                    </button>
                    <button
                        onClick={handleDelete}
                        className="bg-red-500 hover:bg-red-600 text-white py-2 px-4 rounded-md"
                    >
                        Excluir
                    </button>
                </div>
            </div>
        </div>
    );
}
